// #region Functions (1)
/**
 * Helper function to return an IObjectKey
 * @param {string | null} id
 * @param {string} name
 * @return {IObjectKey}
 */
export function createObjectKey(id, name) {
  if (id === null) {
    throw new Error("Id cannot be null");
  }
  if (name) {
    return {
      id: id,
      name: name
    };
  } else {
    return {
      id: id
    };
  }
}
// #endregion Functions (1)